/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Partner_Org_Contract_TermInputs */



/**
* | output |
* | --- |
* | "{start} to {end}" |
*
* @param {Partner_Org_Contract_TermInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_term = /** @type {((inputs: Partner_Org_Contract_TermInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_TermInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.start} bis ${i?.end}`)
	return /** @type {LocalizedString} */ (`${i?.start} to ${i?.end}`)
});